const { getCookie } = require('./get-cookie')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {string} name
 */
function deleteCookie (name) {
  if (typeof document === 'undefined' || !name) return
  if (!getCookie(name)) return

  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT;`
}

module.exports = { deleteCookie }
